"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/EditMessageDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _WizardFrame = require('web/screens/Broadcast/Wizard/WizardFrame');
var _Message = require('web/screens/Broadcast/Wizard/Message'); var _Message2 = _interopRequireDefault(_Message);











const DIALOG_FRAME = { layout: 'dialog' } 

/* Rev 32 V1: the campaign page's Edit message, a dialog over the table. It
 * reuses the wizard's Message step in its dialog layout (Rev 33 T4: the
 * editor, focused, beside a live preview); the Rev 26 draft and the R800-29
 * newer-save check come with it. */
const EditMessageDialog = ({
  isOpen, campaign, focusVariable, onDirtyChange, onClose, onSaved,
}) => (
  _react2.default.createElement(_Modal2.default, {
    isOpen: isOpen,
    title: "Edit message" ,
    className: "broadcast-message-dialog",
    bodyClassName: "broadcast-message-dialog--body",
    onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}

    ,  isOpen && (
      _react2.default.createElement(_WizardFrame.StepFrameProvider, { value: DIALOG_FRAME, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        , _react2.default.createElement(_Message2.default, {
          campaign: campaign,
          isCreating: false,
          focusVariable: focusVariable,
          onBack: onClose,
          onClose: onClose,
          onSaved: onSaved,
          onDirtyChange: onDirtyChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        )
      )
    )
  )
)

exports. default = _react.memo.call(void 0, EditMessageDialog)
